import { MICROSERVICE_CONFIG } from "../../config/configs";
import { authenticatedApi } from "../api";

export const getEmails_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/emails?${params}`
	);
	return response.data;
};

export const getEmailById_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/emails/${params}`
	);
	return response.data;
};

export const updateEmailById_api = async (params) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/emails/${params.id}`,
		params.data
	);
	return response.data;
};

export const getEmailVariablesById_api = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.NOTIFICATION}/emails/${params}/variables`
	);
	return response.data;
};
